import { Path, SVG } from '@wordpress/primitives';

export default (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={ { fill: "none" } } stroke="currentColor" strokeWidth="1.5">
		<Path d="M8.5 14C9 12 12.5 7.5 17 5.5" vectorEffect="non-scaling-stroke" />
		<Path d="M8 14C7.66667 11.1667 9 5 17 3C17.1667 4.66667 17.2 8.6 16 11C14.8 13.4 10.1667 14 8 14ZM8 14L7 16" strokeLinecap="round" vectorEffect="non-scaling-stroke" />
		<Path d="M5 19.25H12" vectorEffect="non-scaling-stroke" />
	</SVG>
);
